/* global attachEvent,breakpointMd, windowWidth, localData */

// **********************************************************
// Open sub filter
// **********************************************************
attachEvent('.has-subfilter > .checkbox .checkbox__label', 'click', (el) => {
  const parentFilter = el.target.closest('.has-subfilter');
  if (windowWidth() < breakpointMd) {
    parentFilter.classList.toggle('is-open-sub');
  }
});

// **********************************************************
// Open filter mobile
// **********************************************************
attachEvent('.filter__trigger', 'click', () => {
  document.body.classList.toggle('is-open-filter');
});

// **********************************************************
// Close filter mobile
// **********************************************************
attachEvent('.filter__title:not(.sub-filter__title)', 'click', () => {
  document.body.classList.remove('is-open-filter');
});

// *******************************************************************************
// Click on checkbox
// *******************************************************************************

const checkboxElement = document.querySelectorAll('.sub-filter .checkbox__label');

Array.prototype.forEach.call(checkboxElement, (el) => {
  el.addEventListener('click', (ev) => {
    const parentFilter = ev.target.closest('.has-subfilter');
    const parentItem = ev.target.closest('.sub-filter__item');
    const labelText = parentItem.querySelectorAll('.checkbox__label-text')[0];
    const selectedFilterText = parentFilter.querySelectorAll('.checkbox.level-1 .selected-filters')[0];

    if (windowWidth() > breakpointMd) {
      parentItem.classList.toggle('is-selected');
      const selectedSubFilter = parentFilter.querySelectorAll('.is-selected').length;
      selectedFilterText.innerHTML = ` (${selectedSubFilter})`;
    } else if (parentItem.classList.contains('is-selected') && windowWidth() < breakpointMd) {
      const newText = selectedFilterText.innerHTML.replace(`${labelText.innerHTML}, `, '');
      selectedFilterText.innerHTML = newText;
      parentItem.classList.toggle('is-selected');
    } else {
      selectedFilterText.insertAdjacentHTML('beforeend', `${labelText.innerHTML}, `);
      parentItem.classList.toggle('is-selected');
    }

    const selectedSubFilter = parentFilter.querySelectorAll('.is-selected').length;

    if (selectedSubFilter > 0) {
      parentFilter.classList.add('sub-selected');
    } else {
      parentFilter.classList.remove('sub-selected');
    }
  });
});

// *******************************************************************************
// Click on radio button
// *******************************************************************************

const radioElement = document.querySelectorAll('.sub-filter .radio-button__label');

Array.prototype.forEach.call(radioElement, (el) => {
  el.addEventListener('click', (ev) => {
    const parentFilter = ev.target.closest('.has-subfilter');
    const parentItem = ev.target.closest('.sub-filter__item');

    if (windowWidth() > breakpointMd) {
      parentItem.classList.toggle('is-selected');
    } else if (parentItem.classList.contains('is-selected') && windowWidth() < breakpointMd) {
      parentItem.classList.toggle('is-selected');
    } else {
      parentItem.classList.toggle('is-selected');
    }

    const selectedSubFilter = parentFilter.querySelectorAll('.is-selected').length;

    if (selectedSubFilter > 0) {
      parentFilter.classList.add('sub-selected');
    } else {
      parentFilter.classList.remove('sub-selected');
    }
  });
});

// **********************************************************
// Close sub filter - Mobile
// **********************************************************
attachEvent('.sub-filter__title', 'click', (el) => {
  const parentFilter = el.target.closest('.has-subfilter');
  parentFilter.classList.remove('is-open-sub');
});

// **********************************************************
// Uncheck sub filters
// **********************************************************
attachEvent('.has-subfilter .checkbox.level-1', 'click', (el) => {
  if (windowWidth() > breakpointMd) {
    const parentFilter = el.target.closest('.has-subfilter');
    const parentCheckbox = parentFilter.querySelectorAll('.checkbox.level-1 input')[0];
    const subCheckboxs = parentFilter.querySelectorAll('.checkbox input');
    const subCheckboxsParent = parentFilter.querySelectorAll('.sub-filter__item');
    parentFilter.classList.remove('sub-selected');
    const selectedFilterText = parentFilter.querySelectorAll('.checkbox.level-1 .selected-filters')[0];

    subCheckboxsParent.forEach((elem) => {
      elem.classList.remove('is-selected');
    });

    const checked = false;
    subCheckboxs.forEach((elem) => {
      if (checked !== elem.checked) {
        elem.click();
      }
    });
    parentCheckbox.click();
    selectedFilterText.innerHTML = '';
  }
});

// **********************************************************
// Reset filter
// **********************************************************
attachEvent('.filter__reset', 'click', () => {
  const allCheckboxInput = document.querySelectorAll('.checkbox input');
  const selectedFilterText = document.querySelectorAll('.checkbox.level-1 .selected-filters');
  const subFiltersParent = document.querySelectorAll('.has-subfilter');
  const checked = false;

  allCheckboxInput.forEach((elem) => {
    if (checked !== elem.checked) {
      elem.click();
    }
  });

  selectedFilterText.forEach((elem) => {
    // eslint-disable-next-line no-param-reassign
    elem.innerHTML = '';
  });

  subFiltersParent.forEach((elem) => {
    elem.classList.remove('sub-selected');
  });
  const ele = document.querySelectorAll('.clickable-check');
  for (let i = 0; i < ele.length; i++) {
    ele[i].checked = false;
  }
});

// **********************************************************
// Ajax call
// **********************************************************
const reset = document.querySelector('.filter__reset');
if (reset) {
  const loading = document.querySelector('.menu-overlay');
  const { type } = document.querySelector('.sc-list-module').dataset;
  const noResultText = document.querySelector('.sc-list-module').dataset.noresults;
  const radios = document.querySelectorAll('.filter__list input.clickable-check');
  const list = document.querySelector('.sc-list-module .article-container');
  const moreButton = document.querySelector('.list-module__button');
  const renderMainResults = (clearScreen) => {
    loading.classList.add('is-visible');
    const tempData = {};
    for (let i = 0, { length } = radios; i < length; i += 1) {
      if (radios[i].checked) {
        tempData[i] = radios[i].getAttribute('id');
      }
    }
    // eslint-disable-next-line no-unused-expressions
    Object.keys(tempData).length ? (reset.hidden = false) : (reset.hidden = true);
    const offset = document.querySelectorAll('.list-block').length;
    const request = new XMLHttpRequest();
    request.open('POST', localData.siteURL, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    request.send(
      `action=filterJobOrWeapon&type=${type}&clearScreen=${clearScreen}&offset=${offset}&radio=${encodeURI(JSON.stringify(tempData))}`,
    );
    request.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        const response = JSON.parse(this.responseText);
        if (clearScreen) {
          list.innerHTML = '';
        }
        moreButton.hidden = !!response.data.showingAll;
        if (response.data.all) {
          let prodHtml = '';
          response.data.data.forEach((elm) => {
            let leftKey = '';
            let rightKey = '';
            if (elm.left_keydata_list) {
              elm.left_keydata_list.forEach((el) => {
                leftKey += `<li>
                                            <div class="key-data__list-title">
                                                <div class="key-data__list-icon">
                                                <img src="${el.icon_src}" alt="${el.icon_src}">
                                                </div>
                                                <strong>${el.title}</strong>
                                            </div>
                                            <div class="key-data__list-text">
                                                <span>${el.text}</span>
                                            </div>
                                            </li>`;
              });
            }
            if (elm.right_keydata_list) {
              elm.right_keydata_list.forEach((er) => {
                rightKey += `<li>
                                              <div class="key-data__list-title">
                                                <div class="key-data__list-icon">
                                                  <img src="${er.icon_src}" alt="${er.icon_src}">
                                                </div>
                                                <strong>${er.title}</strong>
                                              </div>
                                              <div class="key-data__list-text">
                                                <span>${er.text}</span>
                                              </div>
                                            </li>`;
              });
            }
            prodHtml += `<article class="list-block : ${type === 'weapon' ? 'list-block--equipment' : ''}">
                                                <div class="list-block__image">
                                                <div class="image-aspect : image-aspect--cover">
                                                    <div class="image-aspect__bg" data-responsive="responsive-bg-image" style="background-image: url(${elm.image_src});">
                                                        <img class="responsive-bg-img ls-is-cached lazyloaded" width="1024" src="${elm.image_src}" data-src="${elm.image_src}" alt="">
                                                    </div>
                                                </div>
                                                  </div>
                                                  <div class="list-block__content">
                                                      <div class="list-block__content-inner">
                                                      <div class="list-block__category : text--14 : text--uppercase">${elm.category}</div>
                                                <div class="title : title--h4">
                                                    <h4>${elm.title}</h4>
                                                  </div>
                                                <div class="body-text : body-text--16">
                                                  <p>${elm.text}</p>
                                                </div>
                                                      <div class="list-block__footer">
                                                        <div class="key-data">
                                                          <div class="key-data__placeholder">
                                                            <span>${elm.keydata_placeholder}</span>
                                                <i class="icon : icon-chevron-down" aria-hidden="true"></i>
                                                          </div>
                                                        </div>
                                                <a class="btn" href="${elm.button_url}" role="button">
                                                  <span>${elm.button_text}</span>
                                                </a>
                                                      </div>
                                                    </div>
                                                    <div class="list-block__content-collapsible">
                                                      <div class="row">
                                                        <div class="col-md-6 : col-xs-12">
                                                            <ul class="key-data__list">
                                                                ${leftKey}
                                                            </ul>
                                                        </div>
                                                        <div class="col-md-6 : col-xs-12">
                                                            <ul class="key-data__list">
                                                                ${rightKey}
                                                            </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </article>`;
          });
          list.innerHTML += prodHtml;
          if (Object.values(response.data.filters).length > 0) {
            document.querySelectorAll('.sub-filter .checkbox input').forEach((e) => {
              // eslint-disable-next-line radix
              if ((Object.values(response.data.filters).includes(parseInt(e.getAttribute('id'))))) {
                e.closest('.checkbox').classList.remove('disabled');
              } else {
                e.closest('.checkbox').classList.add('disabled');
              }
            });
          } else {
            document.querySelectorAll('.sub-filter .checkbox input').forEach((e) => {
              e.closest('.checkbox').classList.remove('disabled');
            });
          }
        } else {
          list.innerHTML += `<p>${noResultText}</p>`;
        }
        document.querySelector('.result-indicator__text').innerHTML = response.data.showingText;
        document.querySelector('.result-indicator__progress-bar').style.width = `${response.data.barWidth}%`;
        loading.classList.remove('is-visible');
        moreButton.querySelector('a').blur();
      }
    };
  };
  attachEvent('.filter__reset', 'click', () => {
    setTimeout(() => {
      renderMainResults(true);
    }, 300);
  });
  const elementsArray = document.querySelectorAll('.filter__list .clickable-check');
  elementsArray.forEach((elem) => {
    elem.addEventListener('click', (e) => {
      e.stopPropagation();
      setTimeout(() => {
        renderMainResults(true);
      }, 300);
    });
  });
  attachEvent('.list-module__button .btn', 'click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    renderMainResults(false);
  });
  attachEvent('.show-selected', 'click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    document.querySelector('body').classList.remove('is-open-filter');
  });
}
